import axios from 'axios';

const baseURL = `${process.env.NODE_ENV === 'local' ? 'http://localhost:80' : ''}/api`;

export default axios.create({
	baseURL,
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
});
